<template>
    <div class="profile-order-guess" >
        <div class="guess-tip">
            <div class="tip-box">
                <img src="../../../assets/security.png" >
                <span>{{$t('guess_tip1')}}</span>
            </div>
            <div class="tip-box">
                <img src="../../../assets/24_hours.png" >
                <span>{{$t('guess_tip2')}}</span>
            </div>
            <div class="tip-box">
                <img src="../../../assets/48hour.png" >
                <span>{{$t('guess_tip3')}}</span>
            </div>
            <div class="tip-box">
                <img src="../../../assets/14_days.png" >
                <span>{{$t('guess_tip4')}}</span>
            </div>
        </div>
        <h1  style="padding-left:20px">{{$t('Guess_you_like')}}</h1>
        <div class="guess-lists">
            <div class="guess-cell" v-for="(item,index) in guessList" :key="index" v-bind:class="{clear:index == 2}">
                <h3 class="goods-title">{{item.goods_name}}</h3>
                <div class="goods-banner">
                    <img :src="item.goods_img" @click="more(item.goods_alias,item.goods_id)">
                </div>
                <div class="guess-order-group">
                    <div class="guess-price">
                        <p class="originalPrice">{{item.goods_unit}}{{item.market_price}}</p>
                        <p class="newPrice">{{item.goods_unit}}{{item.goods_price}}</p>
                    </div>
                    <div class="guess-buy">
                        <p>
                            <Button type="primary" class="buy-now" @click="buyNow(item.goods_id,item.store_count)">
                                {{$t('buy_now')}}
                            </Button>
                        </p>
                        <p>
                            <Button type="text" class="buy-more" @click="more(item.goods_alias,item.goods_id)">
                                {{$t('more')}}
                                <Icon type="chevron-right"></Icon>
                            </Button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="guess-lists2">
            <div class="guess-cell" v-for="(item,index) in guessList">
                <h3 class="goods-title">{{item.goods_name}}</h3>
                <div class="goods-banner">
                    <img :src="item.goods_img">
                </div>
                <div class="guess-order-group">
                    <div class="guess-price">
                        <p class="newPrice">{{item.goods_unit}}{{item.goods_price}}</p>
                    </div>
                    <div class="guess-buy">
                        <p>
                            <Button type="primary" class="buy-now" @click="buyNow(item.goods_id,item.store_count)">
                                {{$t('buy_now')}}
                            </Button>
                        </p>
                        <p>
                            <Button type="text" class="buy-more" @click="more(item.goods_alias,item.goods_id)">
                                {{$t('more')}}
                                <Icon type="chevron-right"></Icon>
                            </Button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div style="clear: both"></div>
        <a class="guess-refresh" href="javascript:;" @click="refreshGoods">
            {{$t('Guess_you_like_refresh')}}
            <Icon type="android-refresh"></Icon>
        </a>
    </div>
</template>
<script>
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                guessList: [],
                id: ''
            }
        },
        created () {
            this.refreshGoods()
        },
        methods: {
            //详情
            more (alias, id) {
                if (alias === null) {
                    this.$router.push({
                        name: 'ProductDetails',
                        params: {
                            id: id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/product/' + alias +'?id='+id
                    })
                }
            },
            //立即购买
            buyNow (id, store_count) {
                if (store_count === 0) {
                    this.$Message.error(this.$t('user_message_store_count_null'))
                } else {
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: id,
                            number: 1
                        }
                    })
                }

                if(this.Local.get('users')=== null){
                    this.$Message.error(this.$t('user_message_please_login'))
                    this.$router.push({
                        name: 'Login',
                    })
                }else{
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: id,
                            number: 1
                        }
                    })
                }
            },
            //换一组
            refreshGoods () {
                let module = 'index.php/index/goods/guessyoulike'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module)
                .then(function (response) {
                    this.guessList = response.data.data.goods_list
                }.bind(this))
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../scss/personal/guess";
</style>



// WEBPACK FOOTER //
// Guess.vue?5a931b8c